<template>
  <section v-if="tebList.length > 0 || addRegion.length > 0">
    <div class="form">
      <el-form
        :model="ruleForm"
        status-icon
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('已选条件')"
          prop="pass"
          v-if="
            (indexList != -1 || indexCrage != -1) &&
            (check.length > 0 || checkAdd.length > 0)
          "
        >
          <el-tag
            closable
            @close="handleClose(item)"
            v-for="(item, index) in check"
            :key="index"
            v-if="check.length != 0"
            >{{ $t("分类") }}:{{ item }}</el-tag
          >
          <el-tag
            closable
            @close="handleClose(item)"
            v-for="(item, index) in checkAdd"
            :key="index"
            v-if="checkAdd.length != 0"
            >{{ $t("地区") }}:{{ item }}</el-tag
          >
        </el-form-item>
        <el-form-item :label="$t('分类')" prop="checkPass">
          <template>
            <span
              v-for="(item, index) in tebList"
              :key="index"
              :class="['isActive', index == indexCrage ? 'Active' : '']"
              @click="crageClick(item, index)"
              >{{ item.name }}</span
            >
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('地区')"
          prop="checkPass"
          v-if="type != 9 && type != 3 && type != 10 && type != 5 && type != 8"
        >
          <template>
            <span
              v-for="(item, index) in addRegion"
              :key="index"
              :class="['isActive', index == indexList ? 'Active' : '']"
              @click="regionClick(item, index)"
              >{{ item.area_name }}</span
            >
          </template>
        </el-form-item>
      </el-form>
      <el-tag
        type="info"
        class="clearDelete"
        @click="removeClick"
        v-if="check.length > 0 || checkAdd.length > 0"
        style="cursor: pointer"
        >{{ $t("清除筛选") }}</el-tag
      >
    </div>
  </section>
</template>

<script>
import Service from "@/api/request/index.js";
export default {
  name: "filter",
  data() {
    return {
      ruleForm: {
        pass: "",
        checkPass: "",
        age: "",
        indexList: 0,
      },
      addRegion: [],
      classification: [
        { id: 0, name: this.$t("整租") },
        { id: 1, name: this.$t("合租") },
      ],
      indexList: -1, //地区
      indexCrage: -1, //分类
      tebList: [], //导航栏
      check: [], //选择分类
      checkAdd: [],
    };
  },
  props: ["type"],
  // filters: {
  //     capitalize: function (value) {
  //         console.log("value", value)
  //         if (!value) return ''
  //         value = value.toString()
  //         return value.charAt(0).toUpperCase() + value.slice(1)
  //     }
  // },
  created() {
    //   十类文章分类接口
    this.post62bbebb06f8ac();
    if (this.type == 7) {
      this.post62bd4f3c2df91();
    }
  },
  methods: {
    //   地区
    regionClick(row, index) {
      console.log("row", row);
      this.indexList = index;
      this.checkAdd = [];
      this.checkAdd.push(row.area_name);
      this.$emit("regionClick", row);
    },
    // 分类
    crageClick(row, index) {
      this.indexCrage = index;
      this.check = [];
      this.check.push(row.name);
      this.$emit("crageClick", row);
    },
    // 清除筛查
    removeClick() {
      this.check = [];
      this.indexCrage = -1;
      this.indexList = -1;
      this.$emit("removeClick");
    },
    //十类文章分类接口
    post62bbebb06f8ac() {
      Service.post62bbebb06f8ac({ type: this.type }).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          // this.tebList = res.data;
          if (this.type == 7)
            return (this.tebList = [
              { name: "整租", id: 0 },
              { name: "合租", id: 1 },
            ]);
          this.tebList = res.data;
        }
      });
    },
    // 区域列表
    post62bd4f3c2df91() {
      Service.post62bd4f3c2df91({ type: this.type }).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.addRegion = res.data;
        }
      });
    },
    // 清除
    handleClose(tag) {
      this.check.splice(this.check.indexOf(tag), 1);
    },
    // 去重
    // noRepeat3(arr) {
    //     var newArr = arr.filter(function(value, index, self) {
    //         return self.indexOf(value) === index;
    //     });
    //     return newArr;
    // }
  },
};
</script>

<style scoped lang="scss">
.Active {
  color: #559aff !important;
  border-bottom: 1px solid #559aff !important;
}
.isActive {
  cursor: pointer;
  font-size: 16px;
  border-bottom: none;
  color: #333333;
  margin-left: 40px;
}
.isActive:first-child {
  margin-left: 0;
}
/deep/ .el-form-item__label {
  font-size: 16px;
}
.form {
  position: relative;
}
.clearDelete {
  position: absolute;
  right: 24px;
  top: 32px;
}
/deep/ .el-tag {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/filter.vue